import React from "react";
import styled from "styled-components";
import { parseSessionIsoDateForDisplay } from '../../../utils/dates';
import { ucFirst } from '../../../utils/strings';

const MovieTitle = styled.h5`
  font-family: var(--ff-title);
  font-size: ${(30 / 12.6).toFixed(2)}rem;
  text-transform: uppercase;

  body.theme-market & {
    text-transform: none;
  }

  body.theme-platinum & {
    color: var(--primary);
  }
`;

function CheckoutSidebarMovieBlock({ movie, cinema, session }) {
    if (!cinema || !movie || !session) {
        return null;
    }

    const date = parseSessionIsoDateForDisplay(session.datetime);

    return <div className="row mb-5">
        <div className="col-4">
            <img className="img-fluid" src={movie.poster_small} alt="" />
        </div>
        <div className="col-8">
            <MovieTitle>{movie.name}</MovieTitle>
            <p>
                {cinema.name}
                <br />
                {ucFirst(date.format('dddd D [de] MMMM'))}
                <br />
                {date.format('hh:mm A')}
                <br />
                Sala {session.screen_number}
                <br />
                {movie.label}
            </p>
        </div>
    </div>;
}

export default CheckoutSidebarMovieBlock;